import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
} from '@mui/material';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MenuIcon from '@mui/icons-material/Menu';

export default function MobileBottomNav({ onOpenMenu, userRole = 'ROLE_ADMIN' }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isCashier = userRole === 'ROLE_CASHIER';

  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/pos') return 0;
    if (path === '/kitchen-display') return 1;
    if (path === '/') return 2;
    if (isCashier && path === '/timeclock') return 3;
    if (!isCashier && path === '/inventory') return 3;
    return -1;
  };

  const handleTabChange = (event, newValue) => {
    if (newValue === 0) navigate('/pos');
    else if (newValue === 1) navigate('/kitchen-display');
    else if (newValue === 2) navigate('/');
    else if (newValue === 3) {
      navigate(isCashier ? '/timeclock' : '/inventory');
    } else if (newValue === 4) {
      if (onOpenMenu) onOpenMenu();
    }
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        display: { xs: 'flex', md: 'none' },
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        pb: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <BottomNavigation
        showLabels
        value={getActiveTab()}
        onChange={handleTabChange}
        sx={{
          width: '100%',
          height: 56,
          bgcolor: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            py: 0.5,
            px: 0.5,
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main',
              '& .MuiBottomNavigationAction-label': {
                fontWeight: 700,
                fontSize: '0.72rem',
              },
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.68rem',
            fontWeight: 500,
            mt: 0.25,
            transition: 'all 0.15s ease',
          },
        }}
      >
        <BottomNavigationAction label="POS" icon={<PointOfSaleIcon fontSize="small" />} />
        <BottomNavigationAction label="Kitchen" icon={<LocalDiningIcon fontSize="small" />} />
        <BottomNavigationAction label="Dashboard" icon={<DashboardIcon fontSize="small" />} />
        <BottomNavigationAction
          label={isCashier ? 'Timeclock' : 'Inventory'}
          icon={isCashier ? <AccessTimeIcon fontSize="small" /> : <InventoryIcon fontSize="small" />}
        />
        <BottomNavigationAction
          label="More"
          icon={<MenuIcon fontSize="small" />}
          onClick={onOpenMenu}
        />
      </BottomNavigation>
    </Paper>
  );
}
